import { useSubdomain } from '../../../../utils/contexts/UrlProvider'

export const useIsTemplatesWorkspace = () => {
  const workspace = useSubdomain()
  return workspace === 'templates'
}
